import { MAX_RECENT_EDITS, type RecentEditRecord } from '@/core/persistence/types'

export function recentEditIdsToEvict(
  records: readonly RecentEditRecord[],
  limit = MAX_RECENT_EDITS,
): readonly string[] {
  if (!Number.isInteger(limit) || limit < 0) throw new Error('Recent-edit limit must be a non-negative integer')
  return [...records]
    .sort((first, second) => second.updatedAt - first.updatedAt)
    .slice(limit)
    .map((record) => record.id)
}
